<template>
  <div class="progress">
    <div class="progress-bar">
      <div class="progress-bar__inner" :style="style"></div>
    </div>
    <div class="progress-text">{{ percentage }}%</div>
  </div>
</template>

<script>
export default {
  name: 'Progress',
  props: {
    percentage: {
      type: Number,
      require: true
    }
  },
  computed: {
    style () {
      return {
        width: `calc(${this.percentage}%)`
      }
    }
  }
}
</script>

<style lang="less" scoped>
.progress{
  width: 250px;
  display: flex;
  align-items: center;
  &-bar {
    display: inline-block;
    vertical-align: middle;
    flex: 1 0 auto;
    box-sizing: border-box;
    height: 8px;
    border-radius: 4px;
    background-color: rgba(84,142,248,.2);
    border: 1px solid #d8d8d8;
    position: relative;
    &__inner {
      height: 100%;
      background: #519bff;
      border-radius: 4px;
    }
  }
  &-text {
    font-size: 14px;
    color: #606266;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    margin-right: 10px;
    line-height: 1;
  }
}
</style>
